import moment from 'moment';

export default function genererCritereRechercheSituation(societeId) {
  return {
    agences: [],
    dateSituation: (moment().endOf('month')).toDate(),
    societeId: societeId,
    dateDebut: null,
    dateFin: null,
  };
}
